var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 41.5512L11.0552 36.2749L17.9103 29.74H8.22857L8.22857 22.2854L17.9103 22.2854L11.0552 15.7505L16.59 10.4741L23.4451 17.009L23.4451 7.7795H31.2649L31.2649 17.009L38.1199 10.4741L43.6547 15.7505L36.7997 22.2854L46.4814 22.2854L46.4814 29.74L36.7997 29.74L43.6547 36.2749L38.1199 41.5513L31.2649 35.0163V44.2459L23.4451 44.2459V35.0163L16.59 41.5512Z",
    fill: "#1BA56F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.854 26.0266L26.0603 29.2329L32.4728 22.8203",
    stroke: "white",
    strokeWidth: 2.43001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/greenStar.7a8f49ab4ed92aab272c38f6bdff6d04.svg";
export { ForwardRef as ReactComponent };